import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import {API_BASE_URL, SITE_NAME} from '../../constants'
import {getSessionPhone} from '../../storage'
import {NavbarBrand} from '../header'
import axios from 'axios'

class ForgotPassword extends Component {


  constructor(props) {
    super(props)
    this.updatePassword = this.updatePassword.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.state = {password_one:'', password_two:''}
    document.title = "Enter new password - Goods Bill"
  }

  handleInputChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }
  updatePassword(e) {
    this.setState({error_response_data: undefined})
    e.preventDefault()
    axios({
      baseURL: API_BASE_URL,
      url:"/update_password/",
      method:"POST",
      data:{password_one:this.state.password_one, password_two:this.state.password_two, phone:getSessionPhone()}
    }).then((response)=>{

      this.props.history.push('/login')
    }).catch(err=>{

      if(typeof err.response !== "undefined" && typeof err.response.data !== "undefined") {
        this.setState({error_response_data:err.response.data})
      }

    })
  }


  render() {

    let error_response_data = this.state.error_response_data
    let errors
    let password_error
    if(typeof error_response_data !== "undefined") {
      errors = error_response_data.errors

      if(typeof errors.phone !== "undefined" && errors.phone.length > 0) {
        password_error = errors.phone[0]
      }
    }
    return (
      <div>
        <nav className="navbar">
          <div className="container">
              <NavbarBrand />
          </div>
        </nav>
        <section>
          <div className="container">
              <div className="row">
                <div className="col-sm-6 col-sm-offset-3">
                  <div className="">
                        <section className="small">
                        <h1 className="text-center">Enter New Password</h1>
                        </section>
                        <form onSubmit={this.updatePassword}>
                          <div className="form-group">
                            <small>Enter password</small>
                            <input type="password" name="password_one" className="form-control " onChange={this.handleInputChange} value={this.state.password_one} />
                          </div>
                          <div className="form-group">
                            <small>Repeat password</small>
                            <input type="password" name="password_two" className="form-control " onChange={this.handleInputChange} value={this.state.password_two} />
                          </div>
                          <span className="text-danger">{password_error}</span>
                          <div className="form-group">
                            <input type="submit" className="btn btn-primary btn-block" value="Submit" />
                          </div>
                        </form>

                  </div>
                </div>
              </div>
          </div>

        </section>
      </div>
    )
  }
}

export default ForgotPassword



// WEBPACK FOOTER //
// ./src/components/auth/resetpassword.js